export default "__VITE_ASSET__CZ_$lZaB__"